import { createContext, useContext, useState } from "react";

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "af", label: "AF", name: "Afrikaans" },
  { code: "es", label: "ES", name: "Español" },
  { code: "zh", label: "中文", name: "中文" },
];

export const translations = {
  en: {
    nav: { work: "Work", demos: "Demos", studio: "Studio", contact: "Contact", letstalk: "Let's talk" },
    hero: {
      badge: "Creative Director — Portfolio ©2026",
      tagline: "I shape brands, art direction and motion into experiences that",
      taglineAccent: "refuse to be forgotten.",
      cta: "Selected Work",
    },
    marquee: ["DESIGN", "ART DIRECTION", "MOTION", "BRAND IDENTITY", "TYPOGRAPHY", "3D", "EDITORIAL"],
    about: {
      label: "Studio",
      title: "A manifesto in three chapters",
      intro: "Independent creative director working across identity, editorial and motion for brands that want to feel inevitable.",
      chapters: [
        { title: "Concept before craft", body: "Every project starts with an idea sharp enough to survive on a napkin. Aesthetics follow meaning — never the other way around." },
        { title: "Tension is the tool", body: "Negative space, scale and restraint create the friction that makes a page feel alive. I design for the pause, not just the pixel." },
        { title: "Motion with intent", body: "Nothing moves for decoration. Animation guides the eye, sets rhythm and turns a static layout into an experience worth remembering." },
      ],
    },
    work: {
      label: "Selected Work", h1: "Case", h2: "Study",
      intro: "One project, obsessed over end to end — from brand identity to the site you'd hand a client.",
      tag: "Brand Identity & Web",
      description: "A full brand and digital identity for Apex Detailing's flagship service — Auto Shine Pro 32. Precision-grade paint correction and ceramic protection, packaged in a dark, premium visual language that mirrors the mirror finish it promises.",
      cta: "Enquire about a project",
    },
    portfolio: {
      label: "Portfolio", h1: "Live", h2: "Demos",
      intro: "Fully built, clickable websites — explore each one live in a new tab.",
      tag: "Live demo",
      blurb: "Concours-level detailing studio — full marketing site with booking flow.",
      demos: {
        "auto-shine-pro-32": "Concours-level detailing studio — full marketing site with booking flow.",
        "brew-hub-518": "Specialty coffee house — menu, story and table reservations.",
      },
      visit: "Visit site",
    },
    contact: {
      label: "Contact", h1: "Let's", h2: "talk",
      intro: "Have a project in mind or just want to say hello? Drop a note and it lands straight in my inbox.",
      name: "Your name", email: "Email", subject: "Subject", message: "Message",
      namePh: "Jane Appleseed", emailPh: "jane@studio.com", subjectPh: "New project enquiry", messagePh: "Tell me about the project…",
      submit: "Send message", sending: "Sending…", phoneLabel: "Or call",
      success: "Message sent — I'll be in touch shortly.", error: "Something went wrong. Please try again.", validation: "Please fill in your name, email and message.",
    },
    footer: { start: "Start a project", role: "Creative Director", tagline: "Designed & built with intent" },
    reviews: {
      label: "Reviews", h1: "Kind", h2: "Words",
      items: [
        { quote: "Jaxson translated a vague brief into a brand that finally feels like us. Every detail was considered.", name: "Mia Bennett", role: "Founder, Apex Detailing" },
        { quote: "The site he delivered doubled our enquiries in a month. Fast, sharp and a genuine pleasure to work with.", name: "Daniel Cross", role: "Director, Northline Studio" },
        { quote: "A rare mix of taste and rigour. He obsesses over the pixels and the strategy behind them.", name: "Sofia Reyes", role: "Head of Brand, Lumen" },
      ],
    },
  },

  af: {
    nav: { work: "Werk", demos: "Demo's", studio: "Ateljee", contact: "Kontak", letstalk: "Kom gesels" },
    hero: {
      badge: "Kreatiewe Direkteur — Portefeulje ©2026",
      tagline: "Ek vorm handelsmerke, kunsrigting en beweging in ervarings wat",
      taglineAccent: "weier om vergeet te word.",
      cta: "Uitgesoekte Werk",
    },
    marquee: ["ONTWERP", "KUNSRIGTING", "BEWEGING", "HANDELSMERK", "TIPOGRAFIE", "3D", "REDAKSIONEEL"],
    about: {
      label: "Ateljee",
      title: "’n Manifes in drie hoofstukke",
      intro: "Onafhanklike kreatiewe direkteur wat werk oor identiteit, redaksioneel en beweging vir handelsmerke wat onvermydelik wil voel.",
      chapters: [
        { title: "Konsep voor vakmanskap", body: "Elke projek begin met ’n idee skerp genoeg om op ’n servet te oorleef. Estetika volg betekenis — nooit andersom nie." },
        { title: "Spanning is die gereedskap", body: "Negatiewe ruimte, skaal en terughoudendheid skep die wrywing wat ’n bladsy lewendig laat voel. Ek ontwerp vir die pouse, nie net die piksel nie." },
        { title: "Beweging met bedoeling", body: "Niks beweeg vir versiering nie. Animasie lei die oog, stel ritme en maak van ’n statiese uitleg ’n ervaring werd om te onthou." },
      ],
    },
    work: {
      label: "Uitgesoekte Werk", h1: "Geval", h2: "Studie",
      intro: "Een projek, van begin tot einde behep — van handelsmerkidentiteit tot die webwerf wat jy aan ’n kliënt sou gee.",
      tag: "Handelsmerk & Web",
      description: "’n Volledige handelsmerk- en digitale identiteit vir Apex Detailing se vlagskipdiens — Auto Shine Pro 32. Presisie verfkorreksie en keramiese beskerming, verpak in ’n donker, premium visuele taal wat die spieëlafwerking weerspieël wat dit belowe.",
      cta: "Navraag oor ’n projek",
    },
    portfolio: {
      label: "Portefeulje", h1: "Lewendige", h2: "Demo's",
      intro: "Ten volle gebou, klikbare webwerwe — verken elkeen lewendig in ’n nuwe oortjie.",
      tag: "Lewendige demo",
      blurb: "Konkoers-vlak verfynstudio — volledige bemarkingswerf met besprekingsvloei.",
      demos: {
        "auto-shine-pro-32": "Konkoers-vlak verfynstudio — volledige bemarkingswerf met besprekingsvloei.",
        "brew-hub-518": "Spesialiteit-koffiehuis — spyskaart, storie en tafelbesprekings.",
      },
      visit: "Besoek werf",
    },
    contact: {
      label: "Kontak", h1: "Kom", h2: "gesels",
      intro: "Het jy ’n projek in gedagte of wil jy net groet? Los ’n nota en dit beland reguit in my inkassie.",
      name: "Jou naam", email: "E-pos", subject: "Onderwerp", message: "Boodskap",
      namePh: "Jan Alleman", emailPh: "jan@ateljee.com", subjectPh: "Nuwe projeknavraag", messagePh: "Vertel my van die projek…",
      submit: "Stuur boodskap", sending: "Stuur tans…", phoneLabel: "Of bel",
      success: "Boodskap gestuur — ek sal binnekort in aanraking wees.", error: "Iets het verkeerd geloop. Probeer asseblief weer.", validation: "Vul asseblief jou naam, e-pos en boodskap in.",
    },
    footer: { start: "Begin ’n projek", role: "Kreatiewe Direkteur", tagline: "Ontwerp & gebou met bedoeling" },
    reviews: {
      label: "Resensies", h1: "Vriendelike", h2: "Woorde",
      items: [
        { quote: "Jaxson het ’n vae opdrag omskep in ’n handelsmerk wat uiteindelik soos ons voel. Elke besonderheid was deurdag.", name: "Mia Bennett", role: "Stigter, Apex Detailing" },
        { quote: "Die webwerf wat hy gelewer het, het ons navrae binne ’n maand verdubbel. Vinnig, skerp en ’n plesier om mee te werk.", name: "Daniel Cross", role: "Direkteur, Northline Studio" },
        { quote: "Skaars mengsel van smaak en noukeurigheid. Hy is behep met die pixels én die strategie daaragter.", name: "Sofia Reyes", role: "Hoof van Handelsmerk, Lumen" },
      ],
    },
  },

  es: {
    nav: { work: "Trabajo", demos: "Demos", studio: "Estudio", contact: "Contacto", letstalk: "Hablemos" },
    hero: {
      badge: "Director Creativo — Portafolio ©2026",
      tagline: "Doy forma a marcas, dirección de arte y movimiento en experiencias que",
      taglineAccent: "se niegan a ser olvidadas.",
      cta: "Trabajo Seleccionado",
    },
    marquee: ["DISEÑO", "DIRECCIÓN DE ARTE", "MOVIMIENTO", "IDENTIDAD DE MARCA", "TIPOGRAFÍA", "3D", "EDITORIAL"],
    about: {
      label: "Estudio",
      title: "Un manifiesto en tres capítulos",
      intro: "Director creativo independiente que trabaja en identidad, editorial y movimiento para marcas que quieren sentirse inevitables.",
      chapters: [
        { title: "Concepto antes que técnica", body: "Cada proyecto comienza con una idea lo bastante nítida como para sobrevivir en una servilleta. La estética sigue al significado, nunca al revés." },
        { title: "La tensión es la herramienta", body: "El espacio negativo, la escala y la contención crean la fricción que hace que una página se sienta viva. Diseño para la pausa, no solo para el píxel." },
        { title: "Movimiento con intención", body: "Nada se mueve por decoración. La animación guía la mirada, marca el ritmo y convierte un diseño estático en una experiencia digna de recordar." },
      ],
    },
    work: {
      label: "Trabajo Seleccionado", h1: "Caso", h2: "de Estudio",
      intro: "Un proyecto, obsesionado de principio a fin — desde la identidad de marca hasta el sitio que le entregarías a un cliente.",
      tag: "Identidad de Marca y Web",
      description: "Una identidad de marca y digital completa para el servicio insignia de Apex Detailing — Auto Shine Pro 32. Corrección de pintura de precisión y protección cerámica, presentadas en un lenguaje visual oscuro y premium que refleja el acabado espejo que promete.",
      cta: "Consultar sobre un proyecto",
    },
    portfolio: {
      label: "Portafolio", h1: "Demos", h2: "en Vivo",
      intro: "Sitios web totalmente construidos y navegables: explora cada uno en vivo en una nueva pestaña.",
      tag: "Demo en vivo",
      blurb: "Estudio de detailing de alto nivel — sitio de marketing completo con flujo de reservas.",
      demos: {
        "auto-shine-pro-32": "Estudio de detailing de alto nivel — sitio de marketing completo con flujo de reservas.",
        "brew-hub-518": "Cafetería de especialidad — menú, historia y reservas de mesa.",
      },
      visit: "Visitar sitio",
    },
    contact: {
      label: "Contacto", h1: "Hable", h2: "mos",
      intro: "¿Tienes un proyecto en mente o solo quieres saludar? Deja una nota y llegará directo a mi bandeja.",
      name: "Tu nombre", email: "Correo", subject: "Asunto", message: "Mensaje",
      namePh: "Juana Pérez", emailPh: "juana@estudio.com", subjectPh: "Nueva consulta de proyecto", messagePh: "Cuéntame sobre el proyecto…",
      submit: "Enviar mensaje", sending: "Enviando…", phoneLabel: "O llama",
      success: "Mensaje enviado — me pondré en contacto pronto.", error: "Algo salió mal. Inténtalo de nuevo.", validation: "Por favor completa tu nombre, correo y mensaje.",
    },
    footer: { start: "Iniciar un proyecto", role: "Director Creativo", tagline: "Diseñado y construido con intención" },
    reviews: {
      label: "Reseñas", h1: "Buenas", h2: "Palabras",
      items: [
        { quote: "Jaxson convirtió un brief impreciso en una marca que por fin nos representa. Cada detalle fue pensado.", name: "Mia Bennett", role: "Fundadora, Apex Detailing" },
        { quote: "El sitio que entregó duplicó nuestras consultas en un mes. Rápido, preciso y un placer trabajar con él.", name: "Daniel Cross", role: "Director, Northline Studio" },
        { quote: "Una rara mezcla de gusto y rigor. Se obsesiona con los píxeles y con la estrategia detrás de ellos.", name: "Sofia Reyes", role: "Directora de Marca, Lumen" },
      ],
    },
  },

  zh: {
    nav: { work: "作品", demos: "演示", studio: "工作室", contact: "联系", letstalk: "联系我" },
    hero: {
      badge: "创意总监 — 作品集 ©2026",
      tagline: "我将品牌、艺术指导与动效塑造成",
      taglineAccent: "令人难以忘怀的体验。",
      cta: "精选作品",
    },
    marquee: ["设计", "艺术指导", "动效", "品牌识别", "字体设计", "三维", "编辑设计"],
    about: {
      label: "工作室",
      title: "三章宣言",
      intro: "独立创意总监，专注于品牌识别、编辑设计与动效，为渴望脱颖而出的品牌服务。",
      chapters: [
        { title: "理念先于技艺", body: "每个项目都始于一个足够锋利、能写在餐巾纸上也成立的想法。美学服务于意义，而非相反。" },
        { title: "张力即工具", body: "留白、尺度与克制营造出让页面充满生命力的张力。我为停顿而设计，而不仅仅是像素。" },
        { title: "有意图的动效", body: "没有任何动效只为装饰。动画引导视线、设定节奏，将静态版面变成值得铭记的体验。" },
      ],
    },
    work: {
      label: "精选作品", h1: "案例", h2: "研究",
      intro: "一个项目，从头到尾精雕细琢——从品牌识别到可直接交付客户的网站。",
      tag: "品牌识别与网站",
      description: "为 Apex Detailing 的旗舰服务 Auto Shine Pro 32 打造的完整品牌与数字识别。精密漆面修复与陶瓷镀膜，以深沉高端的视觉语言呈现，映照其所承诺的镜面光泽。",
      cta: "咨询项目合作",
    },
    portfolio: {
      label: "作品集", h1: "在线", h2: "演示",
      intro: "完整构建、可点击的网站——在新标签页中实时浏览每一个。",
      tag: "在线演示",
      blurb: "顶级汽车美容工作室——含预约流程的完整营销网站。",
      demos: {
        "auto-shine-pro-32": "顶级汽车美容工作室——含预约流程的完整营销网站。",
        "brew-hub-518": "精品咖啡馆——菜单、品牌故事与在线订座。",
      },
      visit: "访问网站",
    },
    contact: {
      label: "联系", h1: "联系", h2: "我",
      intro: "有项目想法，或只是想打个招呼？留言即可直达我的邮箱。",
      name: "您的姓名", email: "邮箱", subject: "主题", message: "留言",
      namePh: "张三", emailPh: "you@studio.com", subjectPh: "新项目咨询", messagePh: "介绍一下您的项目…",
      submit: "发送留言", sending: "发送中…", phoneLabel: "或致电",
      success: "留言已发送——我会尽快与您联系。", error: "出了点问题，请重试。", validation: "请填写您的姓名、邮箱和留言。",
    },
    footer: { start: "开始一个项目", role: "创意总监", tagline: "用心设计与构建" },
    reviews: {
      label: "评价", h1: "客户", h2: "评价",
      items: [
        { quote: "Jaxson 把一份模糊的需求转化为真正代表我们的品牌，每个细节都经过深思熟虑。", name: "Mia Bennett", role: "创始人，Apex Detailing" },
        { quote: "他交付的网站让我们的咨询量在一个月内翻倍。高效、精准，合作十分愉快。", name: "Daniel Cross", role: "总监，Northline Studio" },
        { quote: "品味与严谨的罕见结合。他既专注于像素，也专注于背后的策略。", name: "Sofia Reyes", role: "品牌负责人，Lumen" },
      ],
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("lang") || "en"; } catch { return "en"; }
  });
  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("lang", l); } catch {}
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
